<div *ngIf="permissionRows.length > 0" class="container mx-auto max-h-96">
  <div class="flex">
    <table>
      <thead>
        <tr class="border border-gray-200 text-left h-[57px]">
          <th class="px-6 py-4 bg-gray-200" colspan="2"></th>
        </tr>
        <tr class="border border-gray-200 font-bold text-left h-[81px]">
          <th class="px-6 py-4" colspan="2"></th>
        </tr>
        <tr class="border border-gray-200 text-left h-[57px]">
          <th class="px-6 py-4 font-normal">{{ 'global.customers' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="border border-gray-200 h-[57px]" *ngFor="let row of permissionRows">
          <td class="px-6 py-4 whitespace-nowrap sticky">
            <div class="flex items-center">
              <span>{{ row.label }}</span>
              <span *ngIf="row.groupAction">
                <app-icon
                  fill="none"
                  [iconName]="row.groupAction === PermissionChangeTypeEnum.Added ? 'green-check-mark' : 'red-x'"
                  size="md"></app-icon>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="w-full overflow-x-auto">
      <table class="block w-0">
        <thead>
          <tr class="border border-gray-200 border-l-0 text-left h-[53px]">
            <th
              class="px-6 py-4 bg-gray-200 font-normal"
              [attr.colspan]="header.colSpan"
              *ngFor="let header of headerConfig">
              {{ header.group | translate }}
            </th>
            <th class="px-6 py-4 bg-gray-200" colspan="2"></th>
          </tr>
          <tr class="border border-gray-200 border-l-0 font-bold text-left h-[73px]">
            <ng-container *ngFor="let header of headerConfig">
              <th [attr.colspan]="action.permissions.length" class="px-6 py-4 whitespace-pre-line" *ngFor="let action of header.actions">
                {{ action.title | translate }}
              </th>
            </ng-container>
          </tr>
          <tr class="border border-gray-200 border-l-0 text-left">
            <ng-container *ngFor="let header of headerConfig">
              <ng-container *ngFor="let action of header.actions">
                <th class="px-6 py-4 font-normal h-[57px]" *ngFor="let permission of action.permissions">
                  {{ permission | translate }}
                </th>
              </ng-container>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr class="border border-gray-200 border-l-0" *ngFor="let row of permissionRows">
            <td class="px-6 py-4 text-left" *ngFor="let permission of availablePermissions">
              <ng-container *ngIf="(row | historyPermissionChange: permission) as type">

                <app-icon *ngIf="type === PermissionChangeTypeEnum.Added" iconName="green-check-mark" fill="none" size="md"></app-icon>

                <app-icon *ngIf="type === PermissionChangeTypeEnum.Removed" iconName="red-x" fill="none" size="md"></app-icon>

                <mat-checkbox
                  *ngIf="type === PermissionChangeTypeEnum.Unchanged"
                  [checked]="true"
                  [disabled]="true"
                  color="primary"></mat-checkbox>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
